<div class="message-banner" [ngClass]="'message-banner--' + style">
  <div class="message-banner__icon-wrapper">
    <app-icon [name]="icon" class="message-banner__icon"></app-icon>
  </div>
  <div class="message-banner__text-wrapper">
    <p class="message-banner__header">{{ header }}</p>
    <p class="message-banner__text">{{ text }}</p>
  </div>
</div>
